import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import {
  formatRP,
  getDateToday,
  pembilang,
} from "../../../Utils/externalFunctions";

const styles = StyleSheet.create({
  body: { color: "black", margin: 30, fontSize: 8 },
  column: {
    flexDirection: "column",
  },
  row: {
    flexDirection: "row",
  },
  table: {
    display: "table",
    marginTop: 15,
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableBorderBottom: {
    display: "table",
    marginTop: 10,
    paddingBottom: 10,
    width: "auto",
    borderStyle: "solid",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColNoBorder: {
    borderStyle: "solid",
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
  },
});

const MyDocument = ({
  groupDokumenTransaksi,
  unitKerjaList,
  transaksiList,
}) => {
  let counter = 0;
  const getPimpimpinan = () => {
    const pimpinan = unitKerjaList.find(
      (unit) => unit.nama_unit_kerja === groupDokumenTransaksi?.id_unit_kerja
    );
    return pimpinan?.nama_kepala || "loading";
  };

  const getTelahTerimaDari = () => {
    let userSet = new Set();
    transaksiList.map((item) => {
      userSet.add(item.diajukan_oleh);
    });
    return Array.from(userSet).join(", ");
  };

  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.column}>
        <View style={styles.body}>
          <Text
            style={{
              textAlign: "center",
              fontSize: 14,
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            TANDA TERIMA
          </Text>
          <View style={{ width: "auto" }}>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Telah Terima Dari</Text>
              </View>
              <View style={[styles.row, { width: "2%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "83%" }]}>
                <Text style={{ marginTop: 5 }}>{getTelahTerimaDari()}</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Nomor Surat</Text>
              </View>
              <View style={[styles.row, { width: "2%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "83%" }]}>
                <Text style={{ marginTop: 5 }}>
                  {groupDokumenTransaksi?.kode_group_dokumen}
                </Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Perihal</Text>
              </View>
              <View style={[styles.row, { width: "2%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "83%" }]}>
                <Text style={{ marginTop: 5 }}>
                  Pertanggung Jawaban Keuangan Tanggal{" "}
                  {groupDokumenTransaksi?.tgl}
                </Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Lampiran</Text>
              </View>
              <View style={[styles.row, { width: "2%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "83%" }]}>
                <Text style={{ marginTop: 5 }}>
                  {groupDokumenTransaksi?.group_transaksi.length} Berkas
                </Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Isi Lampiran</Text>
              </View>
              <View style={[styles.row, { width: "2%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "83%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
            {transaksiList?.map((item) => {
              counter++;
              return (
                <View style={styles.tableRow}>
                  <View style={[styles.row, { width: "2%" }]}>
                    <Text style={{ marginTop: 5 }}></Text>
                  </View>
                  <View style={[styles.row, { width: "98%" }]}>
                    <Text style={{ marginTop: 5 }}>
                      {counter}. {item.keterangan}
                      {" Rp "}
                      {formatRP(item.nilai_transaksi)}
                    </Text>
                  </View>
                </View>
              );
            })}
            <View style={styles.tableRow}>
              <View style={[styles.row, { marginTop: 10 }]}></View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "15%" }]}>
                <Text style={{ marginTop: 5 }}>Catatan</Text>
              </View>
              <View style={[styles.row, { width: "5%" }]}>
                <Text style={{ marginTop: 5 }}>:</Text>
              </View>
              <View style={[styles.row, { width: "80%" }]}>
                <Text style={{ marginTop: 5 }}></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.row, { width: "100%" }]}>
                <Text style={{ marginTop: 10 }}>Kepada Yth</Text>
              </View>
            </View>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "5%" }]}>
                <Text style={styles.tableCell}>NO</Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={styles.tableCell}>Nama</Text>
              </View>
              <View style={[styles.tableCol, { width: "35%" }]}>
                <Text style={styles.tableCell}>Nama Penerima</Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={styles.tableCell}>Tanggal</Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={styles.tableCell}>Tanda Tangan</Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "5%" }]}>
                <Text style={styles.tableCell}>1</Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={styles.tableCell}>
                  {groupDokumenTransaksi?.username_pic_keuangan}
                </Text>
              </View>
              <View style={[styles.tableCol, { width: "35%" }]}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={styles.tableCell}></Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={styles.tableCell}></Text>
              </View>
            </View>
          </View>

          <View style={styles.tablenoborder}>
            <View style={[styles.tableRow, { marginTop: 30 }]}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>Pemberi Tugas,</Text>
              </View>
              <View style={[styles.borderWidth, { width: "20%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>Depok, {getDateToday()}</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
            <View style={styles.tableRow}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "20%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>Yang menyerahkan</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
            <View style={[styles.tableRow, { marginTop: 50 }]}>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "20%" }]}>
                <Text>{"(                                )"}</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "10%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "5%" }]}>
                <Text></Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text>{"(                                )"}</Text>
              </View>
              <View style={[styles.borderWidth, { width: "15%" }]}>
                <Text></Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument;
